var React = require('react');

function CheckGreen (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_117","data-name":"Group 117","transform":"translate(-1028 -233)"},[React.createElement("circle",{"id":"Ellipse_1","data-name":"Ellipse 1","fill":"#0ede70","cx":"9.5","cy":"9.5","r":"9.5","transform":"translate(1028 233)","key":0}),React.createElement("path",{"id":"ic_done_24px","fill":"#fff","stroke":"#fff","d":"M6.9,12.225,4.275,9.6l-.875.875,3.5,3.5,7.5-7.5L13.525,5.6Z","transform":"translate(1029.1 232.82)","key":1})]));
}

CheckGreen.defaultProps = {"viewBox":"0 0 19 19"};

module.exports = CheckGreen;

CheckGreen.default = CheckGreen;
